require('./hireWelcomeAccountComponent.scss');

// @vendor
import React from 'react';
import PropTypes from 'prop-types';

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const HireWelcomeAccountStep1 = require('./hireWelcomeAccountSteps/hireWelcomeAccountStep1/hireWelcomeAccountStep1');
const HireWelcomeAccountStep2 = require('./hireWelcomeAccountSteps/hireWelcomeAccountStep2/hireWelcomeAccountStep2');
const HireWelcomeAccountComponentStep3 = require('./hireWelcomeAccountComponentSteps/HireWelcomeAccountComponentStep3');
const { CallMeBack } = require('components/callMeBack/callMeBack');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

//@helpers
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;
const { getLastNChars, toCamelCase } = require('utilities/stringHelper');
const { formatIbanString } = require('commonsUtilities/stringHelper');

//@constants
const {
    ACCOUNT_INTERVENTION_OWNER_CODE,
    ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE,
    ACCOUNT_INTERVENTION_AUTHORIZED_CODE,
    ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE,
    MYPROFILE_ACCOUNTS_URL,
    MYPROFILE_GLOBAL_URL,
    SECOND_STEP
} = require('constants/index');
const INTERVENER_TITLE = {
    [ACCOUNT_INTERVENTION_OWNER_CODE]: 'hireWelcomeAccount-hireWelcomeAccount_IntervenerTitular',
    [ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE]: 'hireWelcomeAccount-hireWelcomeAccount_intervenerRepresentative',
    [ACCOUNT_INTERVENTION_AUTHORIZED_CODE]: 'hireWelcomeAccount-hireWelcomeAccount_intervenerAuthorized',
    [ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE]: 'hireWelcomeAccount-hireWelcomeAccount_intervenerLegalRepresentative'
};

const HireWelcomeAccountComponent = (props) => {
    const {
        actions,
        addIntervener,
        immAccounts,
        immHireWelcomeAccount,
        immProfileFields,
        onCheckboxChange,
        preContractualMail,
        removeIntervener,
        requestInterveners,
        requestProfile,
        resetPrecontractualMail,
        restoreDefaultInterveners,
        sendPreContractualMail,
        setIntervenerType,
        setSelectedAccountValue,
        title
    } = props;

    const buildIntervenerGroup = (immGroup, successInterveners) => {
        const type = immGroup.first().get('typeNumber');
        const title = INTERVENER_TITLE[type];
        const intervenerClass = successInterveners ? 'hire-welcome-account-component__success-summary-card-value' : 'hire-welcome-account-component__summary-card-value';
        const interveners = immGroup.map(immIntervener => (
            <div
                className={intervenerClass}
                key={immIntervener.get('name').toString()}
            >
                {immIntervener.get('name')}
            </div>
        ));
        let content = (
            <div className="hire-welcome-account-component__summary-card-field">
                <FormattedText value={title} />
                {interveners}
            </div>
        );
        if (successInterveners) {
            content = (
                <div className="hire-welcome-account-component__success-summary">
                    {interveners}
                    <FormattedText value={title} />
                </div>
            )
        }
        return content;
    }

    const buildInterveners = (props, successInterveners = false) => {
        const { immHireWelcomeAccount } = props;
        const immInterveners = immHireWelcomeAccount.getIn(['steps', SECOND_STEP, 'interveners']);
        let content;
        if (immInterveners.size) {
            content = immInterveners.groupBy(immIntervener => immIntervener.get('typeNumber'))
                .map(immIntervenerGroup => buildIntervenerGroup(immIntervenerGroup, successInterveners)).toList();
        } else {
            content = (
                <FormattedText
                    className="hire-welcome-account-component__summary-value-pending"
                    value="hireWelcomeAccount-hireWelcomeAccount_toDefine"
                />
            );
        }

        return content;
    }

    const buildSummaryCard = (props, successSummary = false) => {
        const { immAccounts } = props;
        const interveners = buildInterveners(props, successSummary);
        const selectedAccountId = immHireWelcomeAccount.getIn(['steps', SECOND_STEP, 'selectedAccount']);
        const immSelectedAccount = immAccounts.getIn(['byId', selectedAccountId]);
        let accountAlias;
        if (!immSelectedAccount) {
            accountAlias = (
                <FormattedText
                    className="hire-welcome-account-component__summary-value-pending"
                    value="hireWelcomeAccount-hireWelcomeAccount_toDefine"
                />
            );
        } else {
            const iban = immSelectedAccount.get('iban');
            accountAlias = immSelectedAccount.get('aliasTentative') || immSelectedAccount.get('alias') || toCamelCase(immSelectedAccount.get('accountType'));
            accountAlias = `${accountAlias} ${getLastNChars(iban)}`;
        }
        let content;
        if (successSummary) {
            content = (
                <div className="hire-welcome-account-component__success-summary-container">
                    <div className="hire-welcome-account-component__success-summary">
                        <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_associatedAccount" />
                        <span className="hire-welcome-account-component__summary-card-value">
                            {accountAlias}
                        </span>
                    </div>
                    <div className="hire-welcome-account-component__success-summary-right">
                        <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_interveners" />
                        <div>{interveners}</div>
                    </div>
                </div>
            );
        } else {
            content = (
                <OKSectionBox className="">
                    <FormattedText
                        className="hire-welcome-account-component__summary-card-title"
                        value="hireWelcomeAccount-hireWelcomeAccount_summaryCardTitle"
                    />
                    <div className="hire-welcome-account-component__summary-card-field">
                        <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_associatedAccount" />
                        <span className="hire-welcome-account-component__summary-card-value">
                            {accountAlias}
                        </span>
                    </div>
                    <div className="hire-welcome-account-component__summary-card-field">
                        <FormattedText
                            className="hire-welcome-account-component__interveners-title"
                            value="hireWelcomeAccount-hireWelcomeAccount_interveners"
                        />
                        {interveners}
                    </div>
                </OKSectionBox>
            )
        }

        return content;
    }

    const buildWizard = (props) => {
        const {
            breadcrumbTitle,
            confirmationSubtitle,
            confirmationTitle,
            disableSendButton,
            flagBasedFeatures,
            getContractInformation,
            hasPolling,
            immContractualPolling,
            immPreContractualPolling,
            isLegalTextRead,
            onLegalTextRead,
            productName,
            setTermsAndCondsText,
            standar,
            subtype,
            type,
            welcomeAccountPayroll,
            offerAccountData
        } = props;
        const immSteps = immHireWelcomeAccount.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immHireWelcomeAccount.get('visibleStep');
        const immFinalButton = 'hireWelcomeAccount-hireWelcomeAccount_finishButton';
        const intervenersEl = buildInterveners(props);
        const selectedAccountId = immHireWelcomeAccount.getIn(['steps', SECOND_STEP, 'selectedAccount']);
        const contractNumber = immAccounts.getIn(['byId', selectedAccountId, 'oldFullContractNumber']);
        const params = {
            originAccount: contractNumber
        }
        const firstStepDisabled = !immHireWelcomeAccount.getIn(['confirmationCheckboxes', 'value']);
        const secondStepDisabled = !immHireWelcomeAccount.getIn(['steps', SECOND_STEP, 'selectedAccount']);
        const welcomeAccountFetching = immHireWelcomeAccount.get('isFetchingWelcomeAccount') || hasPolling && (immContractualPolling.getIn(['init', 'isFetching']) || immContractualPolling.getIn(['documents', 'isFetching']));
        return (
            <div className="col-xs-12 col-md-8">
                <div className="row">
                    <div className="col-md-12">
                        <div className="hire-welcome-account-component">
                            <Wizard
                                actions={actions}
                                immSteps={immSteps}
                                stepsAmount={stepsAmount}
                                fullWidth={false}
                                visibleStep={visibleStep}
                                showPreLeaveModal
                            >
                                <WizardStep
                                    position="first"
                                    cancelButton
                                    nextButton
                                    nextButtonDisabled={firstStepDisabled}
                                >
                                    <HireWelcomeAccountStep1
                                        contractName={'e-account-loan'}
                                        disableSendButton={disableSendButton}
                                        flagBasedFeatures={flagBasedFeatures}
                                        getContractInformation={getContractInformation}
                                        hasPolling={hasPolling}
                                        immHireWelcomeAccount={immHireWelcomeAccount}
                                        immPreContractualPolling={immPreContractualPolling}
                                        isLegalTextRead={isLegalTextRead}
                                        immProfileFields={immProfileFields}
                                        offerAccountData={offerAccountData}
                                        onLegalTextRead={onLegalTextRead}
                                        onCheckboxChange={onCheckboxChange}
                                        preContractualMail={preContractualMail}
                                        productName={productName}
                                        requestProfile={requestProfile}
                                        resetPrecontractualMail={resetPrecontractualMail}
                                        sendPreContractualMail={sendPreContractualMail}
                                        setTermsAndCondsText={setTermsAndCondsText}
                                        standar={standar}
                                        subType={subtype}
                                        type={type}
                                        welcomeAccountPayroll={welcomeAccountPayroll}
                                    />
                                </WizardStep>
                                <WizardStep
                                    position="middle"
                                    cancelButton
                                    nextButton
                                    previousButton
                                    nextButtonDisabled={secondStepDisabled}
                                >
                                    <HireWelcomeAccountStep2
                                        addIntervener={addIntervener}
                                        flagBasedFeatures={flagBasedFeatures}
                                        immAccounts={immAccounts}
                                        immStep={immSteps.get(SECOND_STEP)}
                                        removeIntervener={removeIntervener}
                                        requestInterveners={requestInterveners}
                                        restoreDefaultInterveners={restoreDefaultInterveners}
                                        setIntervenerType={setIntervenerType}
                                        setSelectedAccountValue={setSelectedAccountValue}
                                        title={breadcrumbTitle}
                                    />
                                </WizardStep>
                                <WizardStep
                                    position="last"
                                    addLoadingBehaviour
                                    cancelButton
                                    previousButton
                                    finishButton
                                    immFinalButton={immFinalButton}
                                    isLoading={welcomeAccountFetching}
                                >
                                    <HireWelcomeAccountComponentStep3
                                        confirmationSubtitle={confirmationSubtitle}
                                        confirmationTitle={confirmationTitle}
                                        immHireWelcomeAccount={props.immHireWelcomeAccount}
                                        operativeName={props.operativeName}
                                        intervenersEl={intervenersEl}
                                        params={params}
                                    />
                                </WizardStep>
                            </Wizard>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const buildError = (props) => {
        const { immGlobalVariables } = props;
        const titleString = 'contractsView-errorTitle';
        const messageString = 'contractsView-errorMessage';
        const inject = immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']);
        const wizardErrorSubMessage = (
            <div>
                <FormattedText
                    value={messageString}
                    injectedStrings={inject}
                    className="contract-view__wizard-error-sub-message"
                />
            </div>
        );
        const errorBackButtonLabel = 'contractsView-errorBackButtonLabelGlobal';
        const errorBackButtonLink = MYPROFILE_GLOBAL_URL;
        const goBackButton = {
            label: formatText(errorBackButtonLabel).toUpperCase(),
            url: errorBackButtonLink
        };
        return (
            <div className="col-xs-12 col-md-10">
                <WizardError
                    errorMessage={formatText(titleString)}
                    errorSubMessage={wizardErrorSubMessage}
                    mainButton={goBackButton}
                />
            </div>
        );
    }

    const buildSuccessful= (props) => {
        const successTitlePartial = props.welcomeAccountPayroll ? 'successTitlePayroll' : 'successTitle';
        const successTitleKey = `hireWelcomeAccount-hireWelcomeAccount_${successTitlePartial}`;
        const successTitle = formatText(successTitleKey);
        const successSubTitlePartial = props.welcomeAccountPayroll ? 'successSubTitlePayroll' : 'successSubTitle';
        const successSubTitleKey = `hireWelcomeAccount-hireWelcomeAccount_${successSubTitlePartial}`;
        const welcomeAccountNumber = formatIbanString(immHireWelcomeAccount.get('hireWelcomeAccountNumber'));
        const successSubTitle = `${formatText(successSubTitleKey)} ${welcomeAccountNumber}`
        const backButtonUrl = MYPROFILE_ACCOUNTS_URL;
        const goBackButton = {
            label: formatText('contractSummary-backTextAccount'),
            url: backButtonUrl
        };
        const summaryCard = buildSummaryCard(props, true)
        return (
            <div className="col-xs-12 col-md-10">
                <WizardSuccess
                    successMessage={successTitle}
                    successSubMessage={successSubTitle}
                    mainButton={goBackButton}
                >
                    {summaryCard}
                </WizardSuccess>
            </div>
        );
    }

    const buildSidebarContent = (props) => {
        const summaryCard = buildSummaryCard(props);
        return (
            <div className="col-xs-12 col-md-4">
                <div className="row">
                    <div className="col-xs-6 col-md-12">
                        {summaryCard}
                    </div>
                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                        <CallMeBack context="contracts" pageTitle={props.title}/>
                    </div>
                </div>
            </div>
        )
    }

    const mappingBreadcrumb = [
        {
            text: formatText('breadcrumb-accounts'),
            url: MYPROFILE_ACCOUNTS_URL
        },
        {
            text: props.breadcrumbTitle,
            url: ''
        }
    ];

    let content;
    const sidebarContent = !immHireWelcomeAccount.get('hireWelcomeAccountSuccessful') && !immHireWelcomeAccount.get('hireWelcomeAccountError') && !props.error ? buildSidebarContent(props) : null;
    if (immHireWelcomeAccount.get('hireWelcomeAccountSuccessful')) {
        content = buildSuccessful(props);
    } else {
        content = immHireWelcomeAccount.get('hireWelcomeAccountError') || props.error ? buildError(props) : buildWizard(props);
    }

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="pg" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle(title)}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        {content}
                        {sidebarContent}
                    </div>
                </div>
            </div>
        </div>
    );
}

HireWelcomeAccountComponent.propTypes = {
    actions: PropTypes.object,
    addIntervener: PropTypes.func.isRequired,
    breadcrumbTitle: PropTypes.string,
    confirmationSubtitle: PropTypes.string.isRequired,
    confirmationTitle: PropTypes.string.isRequired,
    disableSendButton: PropTypes.bool,
    error: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    getContractInformation: PropTypes.func.isRequired,
    hasPolling: PropTypes.bool,
    immAccounts: PropTypes.object.isRequired,
    immContractualPolling: PropTypes.object,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireWelcomeAccount: PropTypes.object,
    immPreContractualPolling: PropTypes.object,
    immProfileFields: PropTypes.object.isRequired,
    isLegalTextRead: PropTypes.bool,
    onCheckboxChange: PropTypes.object.isRequired,
    onLegalTextRead: PropTypes.func,
    operativeName: PropTypes.string.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    productName: PropTypes.string.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    restoreDefaultInterveners: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setIntervenerType: PropTypes.func.isRequired,
    setSelectedAccountValue: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    standar: PropTypes.string.isRequired,
    subtype: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.string.isRequired,
    welcomeAccountPayroll: PropTypes.bool
}

HireWelcomeAccountComponent.defaultProps = {
    disableSendButton: false,
    error: false,
    hasPolling: false,
    immContractualPolling: null,
    immPreContractualPolling: null,
    isLegalTextRead: null,
    onLegalTextRead: null,
    welcomeAccountPayroll: false
}

export default HireWelcomeAccountComponent;
